import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, tap, map, catchError } from 'rxjs';
import { environment } from '@environments/environment';

const TOKEN_KEY = 'SierraToken';
const LOGIN_URL = `${environment.proxyUrls.userMasterApi}/api/v1/authentication/login`;

interface LoginResponse {
  success: boolean;
  data: string | null;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);

  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  isTokenExpired(): boolean {
    const token = this.getToken();
    if (!token) return true;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const expiry = payload.exp * 1000;
      // Consider expired 60s before actual expiry to avoid race conditions
      return Date.now() > expiry - 60000;
    } catch {
      return true;
    }
  }

  login(): Observable<boolean> {
    if (!this.isTokenExpired()) {
      return of(true);
    }

    return this.http
      .post<LoginResponse>(LOGIN_URL, {
        username: 'tester',
        password: 'password',
      })
      .pipe(
        map((response) => {
          if (response.success && response.data) {
            localStorage.setItem(TOKEN_KEY, response.data);
            return true;
          }
          return false;
        }),
        catchError((err) => {
          console.error('Login failed:', err);
          return of(false);
        }),
      );
  }

  ensureAuthenticated(): Observable<boolean> {
    return this.login();
  }
}
